// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3R5tG","img":"style_img__1YSk3"};